/**
 * AllReviews Component
 *
 * This component is responsible for displaying all reviews for a specific
 * doctor. It includes a page header with a title and a back button that
 * navigates the user to the previous page. The reviews are displayed
 * using the ReviewComponents component, which takes the doctor's ID as a prop.
 * Date: 01-10-2024
 */

import { customer, doctor } from "src/lib/constans";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "src/Components/Customer/PageHeader";
import ReviewComponents from "src/Components/ReviewComponents";
import BackIcon from "src/assets/images/back-icon.png";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AllReviews: React.FC = () => {
  const navigate = useNavigate();
  const { id = "" } = useParams();
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const BackButton: React.FC = () => {
    return (
      <button className="right-bar-icon" onClick={() => navigate(-1)}>
        <img src={BackIcon} alt="back-icon" />
      </button>
    );
  }; // display back icon in page header
  return (
    <>
      {userDetails?.userRole === doctor && (
        <PageHeader
          title="Reviews"
          isButton={true}
          ButtonComponent={BackButton}
        />
      )}
      {userDetails?.userRole === customer ? (
        <div className="view-area-width box-design my-3 lg:my-[1vw]">
          <div className="flex p-4 pb-0">
            <GradientBtn
              ButtonText="Back to Doctor Profile"
              onPress={() => navigate(`/doctor-public-profile/${id}/view`)}
              leftIcon={<FontAwesomeIcon icon={faArrowLeft}  />}
            />
          </div>
          <ReviewComponents id={id} mainClass="!py-1" />
        </div>
      ) : (
        <div className="parent-box">
          <ReviewComponents id={id} />
        </div>
      )}
    </>
  );
};

export default AllReviews;
